import { IJxtBookablePicto } from './types';
import { PATH_CENTERY } from '@jooxter/utils/src/occupation-status/constants';
import { getOccupationFill, getStatusFill } from '@jooxter/utils/src/occupation-status/getPictosStyles';
import { ResourceStateDtoStatusEnum } from '@jooxter/api';

import { getSvgProperties } from '@jooxter/utils/src/occupation-status/getSvgProperties';
import { ResourceOccupationStatusEnum } from '@jooxter/utils';

const JxtBookablePicto = ({ radius = 30, occupationStatus, x, y, size, status }: IJxtBookablePicto) => {
  const { centerX, centerY, scale, badgeOffset } = getSvgProperties(x, y, radius, size, occupationStatus);

  const shouldShowOccupationBadge =
    occupationStatus &&
    !(
      occupationStatus === ResourceOccupationStatusEnum.Default ||
      (occupationStatus === ResourceOccupationStatusEnum.Unoccupied && status !== ResourceStateDtoStatusEnum.Busy)
    );

  return (
    <g>
      <circle cx={centerX} cy={centerY} r={radius} fill={getStatusFill(status)} strokeWidth={radius / 1.9} />
      <path
        d="M11.25 32.125C11.25 33.1797 12.0703 34 13.125 34H26.875C27.8906 34 28.75 33.1797 28.75 32.125V21.5H11.25V32.125ZM23.75 24.4688C23.75 24.2344 23.9453 24 24.2188 24H25.7812C26.0156 24 26.25 24.2344 26.25 24.4688V26.0312C26.25 26.3047 26.0156 26.5 25.7812 26.5H24.2188C23.9453 26.5 23.75 26.3047 23.75 26.0312V24.4688ZM23.75 29.4688C23.75 29.2344 23.9453 29 24.2188 29H25.7812C26.0156 29 26.25 29.2344 26.25 29.4688V31.0312C26.25 31.3047 26.0156 31.5 25.7812 31.5H24.2188C23.9453 31.5 23.75 31.3047 23.75 31.0312V29.4688ZM18.75 24.4688C18.75 24.2344 18.9453 24 19.2188 24H20.7812C21.0156 24 21.25 24.2344 21.25 24.4688V26.0312C21.25 26.3047 21.0156 26.5 20.7812 26.5H19.2188C18.9453 26.5 18.75 26.3047 18.75 26.0312V24.4688ZM18.75 29.4688C18.75 29.2344 18.9453 29 19.2188 29H20.7812C21.0156 29 21.25 29.2344 21.25 29.4688V31.0312C21.25 31.3047 21.0156 31.5 20.7812 31.5H19.2188C18.9453 31.5 18.75 31.3047 18.75 31.0312V29.4688ZM13.75 24.4688C13.75 24.2344 13.9453 24 14.2188 24H15.7812C16.0156 24 16.25 24.2344 16.25 24.4688V26.0312C16.25 26.3047 16.0156 26.5 15.7812 26.5H14.2188C13.9453 26.5 13.75 26.3047 13.75 26.0312V24.4688ZM13.75 29.4688C13.75 29.2344 13.9453 29 14.2188 29H15.7812C16.0156 29 16.25 29.2344 16.25 29.4688V31.0312C16.25 31.3047 16.0156 31.5 15.7812 31.5H14.2188C13.9453 31.5 13.75 31.3047 13.75 31.0312V29.4688ZM26.875 16.5H25V14.625C25 14.3125 24.6875 14 24.375 14H23.125C22.7734 14 22.5 14.3125 22.5 14.625V16.5H17.5V14.625C17.5 14.3125 17.1875 14 16.875 14H15.625C15.2734 14 15 14.3125 15 14.625V16.5H13.125C12.0703 16.5 11.25 17.3594 11.25 18.375V20.25H28.75V18.375C28.75 17.3594 27.8906 16.5 26.875 16.5Z"
        fill="white"
        transform={`
  translate(${centerX}, ${centerY})
  scale(${scale / 1.2})
  translate(-20, -${PATH_CENTERY})
`}
      />
      {shouldShowOccupationBadge && (
        <>
          <circle
            cx={centerX + badgeOffset}
            cy={centerY - badgeOffset}
            r={radius / 2.3}
            fill={getOccupationFill(occupationStatus)}
            stroke="white"
            strokeWidth={radius / 20}
            data-testid="occupation-badge"
          />

          <path
            d={
              [ResourceOccupationStatusEnum.Occupied, ResourceOccupationStatusEnum.Unoccupied].includes(
                occupationStatus
              )
                ? 'M34 9.25C35.3672 9.25 36.5 8.13672 36.5 6.75C36.5 5.38281 35.3672 4.25 34 4.25C32.6133 4.25 31.5 5.38281 31.5 6.75C31.5 8.13672 32.6133 9.25 34 9.25ZM35.7383 9.875H35.4062C34.9766 10.0898 34.5078 10.1875 34 10.1875C33.4922 10.1875 33.0039 10.0898 32.5742 9.875H32.2422C30.7969 9.875 29.625 11.0664 29.625 12.5117V13.3125C29.625 13.8398 30.0352 14.25 30.5625 14.25H37.4375C37.9453 14.25 38.375 13.8398 38.375 13.3125V12.5117C38.375 11.0664 37.1836 9.875 35.7383 9.875Z'
                : 'M34.1561 6C32.9061 6 32.0937 6.51562 31.453 7.4375C31.3437 7.59375 31.3749 7.82812 31.5468 7.9375L32.2187 8.45312C32.3749 8.57812 32.6093 8.54688 32.7343 8.39062C33.1249 7.90625 33.4218 7.625 34.0311 7.625C34.5155 7.625 35.1093 7.92188 35.1093 8.39062C35.1093 8.75 34.8124 8.92188 34.3437 9.1875C33.7811 9.5 33.0468 9.89062 33.0468 10.8594V11C33.0468 11.2188 33.2187 11.375 33.4218 11.375H34.5624C34.7655 11.375 34.9374 11.2188 34.9374 11V10.9219C34.9374 10.25 36.8905 10.2188 36.8905 8.40625C36.8905 7.04688 35.4687 6 34.1561 6ZM33.9999 11.8438C33.3905 11.8438 32.9061 12.3281 32.9061 12.9219C32.9061 13.5156 33.3905 14 33.9999 14C34.5937 14 35.078 13.5156 35.078 12.9219C35.078 12.3281 34.5937 11.8438 33.9999 11.8438Z'
            }
            fill="white"
            transform={`translate(${centerX + badgeOffset}, ${centerY - badgeOffset}) scale(${scale / 1.3}) translate(-34, -10)`}
          />
        </>
      )}
    </g>
  );
};

export default JxtBookablePicto;
